import { KeycloakClient } from "./client";

export class KeycloakClientFactory {
    private static instance: KeycloakClient | null = null;

    private constructor() {
    }
    
    public static getInstance(): KeycloakClient {
        if (!KeycloakClientFactory.instance) {
            KeycloakClientFactory.instance = new KeycloakClient();
        }
        return KeycloakClientFactory.instance;
    }
    
}